import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportForm from "../common/support_form.js";

export class KnowledgeBaseFeedbackModel extends IllumioEventEmitter {
    constructor() {
        super();

        this.csrfToken = IllumioSupportForm.getCsrf(false);
    }

        save(payload) {
            console.debug(`save(): » payload: » ${JSON.stringify(payload)}`);
            $.ajax({
                dataType: 'json',
                data: JSON.stringify(payload),
                method: 'post',
                contentType: 'application/json; charset=utf-8',
                url: '/api/v1/knowledge_base/feedback.json',
                error: this.ajaxErrorHandler.bind(this),
                success: this.ajaxSuccessHandler.bind(this),
            });
        }

    ajaxSuccessHandler(data, textStatus, jqXHR) {
        this.success = data.success;
        this.data = data.data;
        
        this.emit('renderSuccessfulSubmission');
        console.info('KnowledgeBaseFeedbackModel: Successfully loaded feedback.json');
        console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);
    }
    
    ajaxErrorHandler(jqXHR, textStatus, errorThrown) {
        // TODO: display error message.
        console.info('ajaxErrorHandler()');
        console.debug(jqXHR);
        console.debug(textStatus);
        console.debug(errorThrown);
    }
}

export class KnowledgeBaseFeedbackView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;

        this.kbFeedbackForm = document.getElementById('kbFeedbackForm');
        this.kbFeedbackModal = document.getElementById('kbFeedbackModal');

        this.model.on('renderSuccessfulSubmission', this.renderSuccessfulSubmissionEventHandler.bind(this));
    }

    renderSuccessfulSubmissionEventHandler() {
        if (this.kbFeedbackModal) {
            this.kbFeedbackModal.show();
        }
        
        if (this.kbFeedbackForm) {
            if (this.kbFeedbackModal) {
                let successContentElement = this.kbFeedbackForm.querySelector('p');
                if (!successContentElement) {
                    successContentElement = document.createElement('p');
                    successContentElement.textContent = `Thank you! We appreciate your feedback.`;
                }
                this.kbFeedbackForm.insertAdjacentElement('afterend', successContentElement);
                this.kbFeedbackForm.classList.add('hidden');
            }
        }
    }
}

export class KnowledgeBaseFeedbackController extends IllumioEventEmitter {
    constructor(model, view) {
        super();

        this.model = model;
        this.view = view;

        this.view.kbFeedbackForm.onsubmit = this.kbFeedbackFormOnSubmitHandler.bind(this);
    }

    kbFeedbackFormOnSubmitHandler(event) {
        event.preventDefault();

        const payload = {
            sfdc_knowledge_id: this.view.kbFeedbackForm['sfdc_knowledge_id'].value,
            score: this.view.kbFeedbackForm['score'].value,
            comment: this.view.kbFeedbackForm['comment'].value,
            authenticity_token: this.model.csrfToken,
        }
        const status = this.model.save(payload);
        console.debug(`kbFeedbackFormOnSubmitHandler(): » status: ${status}`);
    }
}
